import React, { lazy, Suspense } from 'react';

const AlignmentPanelController = lazy(() =>
  import('wix-rich-content-toolbars-modals').then(({ AlignmentPanelController }) => ({
    default: AlignmentPanelController,
  }))
);

const AlignmentPanelComponent = props => (
  <Suspense fallback={<div style={{ width: 38 }} />}>
    <AlignmentPanelController {...props} />
  </Suspense>
);

export default AlignmentPanelComponent;
